var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h640v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009246",
  d: "M0 0h213.3v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ce2b37",
  d: "M426.7 0H640v480H426.7z"
}))));
SvgIt.displayName = "SvgIt";
export { SvgIt as ReactComponent };
export default SvgIt;